export const CHARACTERS = {
  oliver: {
    prototypeId: 'oliver',
    name: 'Oliver',
    spriteId: 'oliver'
  }
};

export const LOCATIONS = {
  hiddenPond: {
    name: 'Hidden Pond',
    spriteId: 'hiddenPond'
  },
  ancientTree: {
    name: 'Ancient Tree',
    spriteId: 'ancientTree'
  },
  windingPath: {
    name: 'Winding Path',
    spriteId: 'windingPath'
  },
  forestClearing: {
    name: 'Forest Clearing',
    spriteId: 'forestClearing'
  }
};
